import { useTranslation } from "react-i18next";

function PostBanner() {
  const { t } = useTranslation();
  return (
    <div>
      <div>
        <div className="text-left ml-5 text-primaryText dark:text-primaryTextDark text-md w-4/5">
          <h1 className="text-3xl font-bold mt-5 mb-5">Why {t("appName")}?</h1>
          <p>
            AutoCare is a convenient and reliable home service platform
            specializing in car washes and comprehensive car care. We bring
            professional car washing, repairs, oil changes, servicing, and more
            right to your doorstep, so you never have to wait in long lines at
            car centers again. Using only premium products, our expert
            technicians deliver top-quality care while you relax comfortably at
            home, ensuring your vehicle looks and performs its best without any
            hassle.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PostBanner;
